const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.genericComponents.errorProvider.errorCancelApplicationModal.';

const ERROR_MODAL_TITLE = `${DOMAIN}title`,
  ERROR_MODAL_CONTENT = `${DOMAIN}content`;

export { ERROR_MODAL_CONTENT, ERROR_MODAL_TITLE };
